import SalesMenuTypeAddForm from './SalesMenuTypeAddForm';

export default SalesMenuTypeAddForm;
